import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import ticketsActions from "../../../redux/ticket/actions";
import { t } from "i18next";
const { Paragraph, Text } = Typography;

const CancelTicketPayment = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.mainReducer);
  const { sendCancelTicketPayment } = ticketsActions;
  const { myPosCompanyId, myPosOrderId } = useParams();

  useEffect(() => {
    if (token.length > 0) {
      dispatch(sendCancelTicketPayment(token, myPosCompanyId, myPosOrderId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    localStorage.removeItem("cart");
    localStorage.removeItem("reservedTickets");
    localStorage.removeItem("ticketExpirationTime");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Result
      className="cancel-ticket-payment-result"
      status="error"
      title={t("unsuccessfulPayment")}
      extra={[
        <a href="/" key="1">
          <Button
            className="custom-button success-ticket-payment-result-back-button"
            type="primary"
          >
            {t("home")}
          </Button>
        </a>,
      ]}
    >
      <div>
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            {t("pleaseCheckFollowingReasons")}
          </Text>
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          {t("youCancelPayment")}
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          {t("unavaibleAmount")}
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          {t("incorrectDetails")}
        </Paragraph>

        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          {t("techicalProblem")}
        </Paragraph>
      </div>
    </Result>
  );
};

export default CancelTicketPayment;
